var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUiIcon8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4915 37.983C25.2169 37.983 28.2369 34.9629 28.2369 31.2376C28.2369 27.5122 25.2169 24.4922 21.4915 24.4922C17.7661 24.4922 14.7461 27.5122 14.7461 31.2376C14.7461 34.9629 17.7661 37.983 21.4915 37.983Z",
    stroke: "url(#paint0_linear_4169_9831)",
    strokeWidth: 2.83571,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1928 37.9844H23.7892C26.7575 37.9843 29.6043 39.1632 31.7034 41.2618C33.8025 43.3605 34.982 46.207 34.9825 49.1753V55.2154C34.9825 55.7051 34.788 56.1747 34.4417 56.5209C34.0955 56.8671 33.6259 57.0616 33.1363 57.0616H9.84615C9.35652 57.0616 8.88695 56.8671 8.54073 56.5209C8.1945 56.1747 8 55.7051 8 55.2154V49.1753C8.00049 46.2071 9.17994 43.3607 11.2789 41.262C13.3779 39.1634 16.2246 37.9844 19.1928 37.9844Z",
    stroke: "url(#paint1_linear_4169_9831)",
    strokeWidth: 2.83571,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2093 35.778C42.1478 35.778 44.5299 33.3958 44.5299 30.4573C44.5299 27.5188 42.1478 25.1367 39.2093 25.1367C36.2708 25.1367 33.8887 27.5188 33.8887 30.4573C33.8887 33.3958 36.2708 35.778 39.2093 35.778Z",
    stroke: "url(#paint2_linear_4169_9831)",
    strokeWidth: 2.83571,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.676 50.8281H48.096C48.5615 50.8265 49.0073 50.6406 49.336 50.3111C49.6647 49.9815 49.8495 49.5351 49.8498 49.0697V46.4204C49.8536 44.4824 49.327 42.5803 48.3272 40.9201C47.3274 39.2598 45.8925 37.9047 44.1778 37.0015C42.4631 36.0983 40.534 35.6814 38.5994 35.7959C36.6648 35.9104 34.7983 36.552 33.2021 37.6512",
    stroke: "url(#paint3_linear_4169_9831)",
    strokeWidth: 2.83571,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7308 21.325C54.7308 20.4659 55.4272 19.7695 56.2862 19.7695H58.4831C59.3421 19.7695 60.0385 20.4659 60.0385 21.325C60.0385 22.5223 61.3347 23.2707 62.3717 22.672C63.1156 22.2425 64.0669 22.4974 64.4965 23.2413L65.5949 25.1438C66.0244 25.8877 65.7695 26.839 65.0255 27.2686C63.9886 27.8673 63.9886 29.364 65.0255 29.9627C65.7695 30.3922 66.0244 31.3435 65.5949 32.0875L64.4965 33.9899C64.0669 34.7339 63.1156 34.9888 62.3717 34.5593C61.3347 33.9606 60.0385 34.709 60.0385 35.9064C60.0385 36.7654 59.3421 37.4618 58.483 37.4618H56.2863C55.4272 37.4618 54.7308 36.7654 54.7308 35.9064C54.7308 34.709 53.4346 33.9606 52.3976 34.5593C51.6537 34.9888 50.7024 34.7339 50.2729 33.99L49.1745 32.0875C48.7449 31.3435 48.9998 30.3922 49.7438 29.9627C50.7808 29.364 50.7808 27.8673 49.7438 27.2686C48.9998 26.839 48.7449 25.8877 49.1745 25.1438L50.2729 23.2413C50.7024 22.4973 51.6537 22.2425 52.3977 22.672C53.4346 23.2707 54.7308 22.5223 54.7308 21.325Z",
    stroke: "url(#paint4_linear_4169_9831)",
    strokeWidth: 2.48125
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9231 28.6157C60.9231 30.5699 59.3389 32.1541 57.3846 32.1541C55.4304 32.1541 53.8462 30.5699 53.8462 28.6157C53.8462 26.6614 55.4304 25.0772 57.3846 25.0772C59.3389 25.0772 60.9231 26.6614 60.9231 28.6157Z",
    stroke: "url(#paint5_linear_4169_9831)",
    strokeWidth: 2.48125
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4169_9831",
    x1: 15.2553,
    y1: 24.129,
    x2: 27.7747,
    y2: 38.3803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4169_9831",
    x1: 9.01855,
    y1: 37.4708,
    x2: 25.0214,
    y2: 63.2362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4169_9831",
    x1: 34.2904,
    y1: 24.8502,
    x2: 44.1654,
    y2: 36.0914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4169_9831",
    x1: 33.8306,
    y1: 35.3721,
    x2: 47.5492,
    y2: 52.6456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4169_9831",
    x1: 49.6014,
    y1: 19.2932,
    x2: 66.1049,
    y2: 37.1723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4169_9831",
    x1: 49.6014,
    y1: 19.2932,
    x2: 66.1049,
    y2: 37.1723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiIcon8);
export default __webpack_public_path__ + "static/media/ui_icon8.dfc091b2d9d29eaea1f7c726d7ad8419.svg";
export { ForwardRef as ReactComponent };